import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import Button from "../../../components/button/Button";
import styles from "../ReportStatistici.module.css"
import Utils from "../../../utils/Utils";
import Calendar from "../../../components/calendar/Calendar";
import RadioButton from "../../../components/radiobutton/RadioButton";
import SelectAutocomplete from "../../../components/selectAutocomplete/SelectAutocomplete";
import SessioneUtente from "../../../sessionManager/SessioneUtente";
import Ruoli from "../../../utils/Ruoli.json";
import OggettiUtili from "../../../utils/OggettiUtili.json";
import CheckBox from "../../../components/checkbox/CheckBox";
import $ from 'jquery'
import Select from "../../../components/select/Select";


class EpatiteNav extends Component {

    state = {
        tipo:"",
        dataDa: "",
        dataA: "",
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this);
    }

    componentDidMount() {
        let stato = this.props.filtri.stato

        if (stato) {
            for (const option of document.querySelectorAll('#malattia option')) {
                option.setAttribute('selected', 'selected');
            }
            if (SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Regionale.descrizione) {
                for (const option of document.querySelectorAll('#ulssNotifica option')) {
                    option.setAttribute('selected', 'selected');
                }
                for (const option of document.querySelectorAll('#ulssAssistenza option')) {
                    option.setAttribute('selected', 'selected');
                }
            }

            stato["malattia"] = ["all"]
            stato["tipoData"] = true
            stato["ulssNotifica"] = ["all"]
            stato["ulssAssistenza"] = ["all"]
            stato["segnalazione"] = true
            stato["possibile"] = true
            stato["probabile"] = true
            stato["confermato"] = true

            $(document).ready(function () {
                $('.selectpicker').selectpicker('refresh')
            });
        }

    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState != this.state) {
            $(document).ready(function () {
                $('.selectpicker').selectpicker('refresh')
            });
        }
    }

    riceviValore(field, event) {
        let stato = this.props.filtri

        if (event) {
            stato[field] = event.target.value
            this.setState({[field]: event.target.value})
        } else {
            stato[field.currentTarget.id] = field.currentTarget.value;
            this.setState({[field.currentTarget.id]: field.currentTarget.value})
        }
        this.props.filtri.setStatePadre({filtri: stato, sendRequest: false})
    }

    disableButtonVisualizza(){
        if(!this.state.tipo ||
                !this.state.dataA ||
                !this.state.dataDa) return true
        else return false
    }

    render() {
        const {t} = this.props;

        const sezione1 = (
            this.props.filtri.rows ?
                    <div className={"row"}>
                       <div className={"col-lg-4"}>
                            <Select
                                id={this.props.filtri.rows["tipo"].id}
                                value={this.state.tipo}
                                onChange={this.riceviValore}
                                functionMap={OggettiUtili.utilitaEpatite.map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}>
                            </Select>
                        </div>
                        <div className={"col-lg-4"}>
                            <Calendar id={this.props.filtri.rows["data"].id}
                                      value={this.state.dataDa}
                                      field={this.props.filtri.rows["data"].fieldDataDa}
                                      onChange={this.riceviValore}
                                      newCalendar={true}
                                      placeholder={this.props.filtri.rows["data"].placeholder}
                                      errorMessage={this.state.dataDa && Utils.isDateInValid(this.state.dataDa) ? "Data non valida" : ""}
                                      error={Utils.isDateInValid(Utils.transformDateForBackend(this.state.dataDa), "-") &&
                                          this.state.dataDa !== ""}
                            />
                        </div>
                        <div className={"col-lg-4"}>
                            <Calendar id={this.props.filtri.rows["data"].id1}
                                      value={this.state.dataA}
                                      field={this.props.filtri.rows["data"].fieldDataA}
                                      onChange={this.riceviValore}
                                      newCalendar={true}
                                      placeholder={this.props.filtri.rows["data"].placeholder1}
                                      errorMessage={this.state.dataA && Utils.isDateInValid(this.state.dataA) ? "Data non valida" : ""}
                                      error={Utils.isDateInValid(Utils.transformDateForBackend(this.state.dataA), "-") &&
                                          this.state.dataA !== ""}
                            />
                        </div>
                    </div> :<></>
        );

        const button = (
            this.props.filtri.rows ?
                <div className={styles.button}>
                    <div className="col-lg-6">
                        <Button className="btnBlu " id={"genera"}
                                text={"Genera report"}
                                onClick={this.props.filtri.applicaFiltri}
                                style={{height: "2rem", width: "10rem", marginTop: "1rem"}}
                                disabled={this.disableButtonVisualizza()}
                        ></Button>
                    </div>
                </div> : <></>
        );

        return (

            <div>
                <p id={"title"} style={{fontWeight: "bold", marginTop: "1rem"}}>{"Criteri di estrazione"}</p>
                <div className={"row"}>
                    {sezione1}
                </div>
                <div style={{paddingBottom: "1rem"}}>
                    {button}
                </div>

            </div>
        );
    }

}

export default withTranslation('common')(EpatiteNav);
